"use client";

import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

type HeaderStore = {
  isShowingMenu: boolean;
  isShowingMobileSearch: boolean;
  isShowingAccountMenu: boolean;
  isSearchVisible: boolean;
  query: string;
};

/**
 * Context store to keep track of header state
 */
const { useStore: useHeaderStore, Provider: HeaderStoreProvider } =
  createContextStore<HeaderStore>(
    {
      isShowingMenu: false,
      isShowingMobileSearch: false,
      isShowingAccountMenu: false,
      isSearchVisible: false,
      query: "",
    },
    { name: "HeaderStore" }
  );

export { useHeaderStore, HeaderStoreProvider };
